import React, { useState, useEffect } from "react";
import { 
    Modal, ModalHeader, ModalBody, Button, 
    Form, FormGroup, Label, Input 
} from "reactstrap";
import axios from "axios";
import {  toast } from "react-toastify";
import { baseUrl } from "../../../../Baseurl/Baseurl";

interface Profile {
    Company?: {
        id?: string;
        companyname?: string;
        licenseno?: string;
        companyaddress?: string;
        contactno?: string;
        companyemail?: string;
    };
}

interface EditCompanyModalProps {
    isOpen: boolean;
    toggle: () => void;
    profile: Profile;
}

const EditCompanyModal: React.FC<EditCompanyModalProps> = ({ isOpen, toggle, profile }) => {
    const [companyData, setCompanyData] = useState({
        companyname: "",
        licenseno: "",
        companyaddress: "",
        contactno: "",
        companyemail: "",
    });

    useEffect(() => {
        if (profile?.Company) {
            setCompanyData({
                companyname: profile.Company.companyname || "",
                licenseno: profile.Company.licenseno || "",
                companyaddress: profile.Company.companyaddress || "",
                contactno: profile.Company.contactno || "",
                companyemail: profile.Company.companyemail || "",
            });
        }
    }, [profile]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCompanyData({ ...companyData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            if (!token) throw new Error("Authentication token missing");
    
            const response = await axios.put(
                `${baseUrl}companydetails/updatecompany/${profile?.Company?.id}`,
                companyData,
                {
                    headers: { Authorization: token },
                }
            );
    
            toast.success("Company details updated successfully!");
            toggle(); // Close modal
        } catch (error: any) {
            if (error.response) {
                // Handle the specific error message from the backend
                const errorMessage = error.response.data.message || "Error updating company details!";
                toast.error(errorMessage);
                console.error("Update Error:", error.response.data.message);
            } else {
                // For network or unexpected errors
                toast.error("Error updating company details!");
                console.error("Update Error:", error.message);
            }
        }
    };
    

    return (
        <>
        <Modal isOpen={isOpen} toggle={toggle}>
     
            <ModalHeader toggle={toggle}>Edit Company Details</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label>Name</Label>
                        <Input type="text" name="companyname" value={companyData.companyname} onChange={handleChange} required />
                    </FormGroup>
                    <FormGroup>
                        <Label>DL No</Label>
                        <Input type="text" name="licenseno" value={companyData.licenseno} onChange={handleChange} required />
                    </FormGroup>
                    <FormGroup>
                        <Label>Address</Label>
                        <Input type="text" name="companyaddress" value={companyData.companyaddress} onChange={handleChange} required />
                    </FormGroup>
                    <FormGroup>
                        <Label>Contact No</Label>
                        <Input type="text" name="contactno" value={companyData.contactno} onChange={handleChange} required />
                    </FormGroup>
                    <FormGroup>
                        <Label>Email</Label>
                        <Input type="email" name="companyemail" value={companyData.companyemail} onChange={handleChange} required />
                    </FormGroup>
                    <Button color="primary" type="submit">Save Changes</Button>
                    <Button color="secondary" onClick={toggle} style={{ marginLeft: "10px" }}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
        </>
    );
};

export default EditCompanyModal;
